import * as yup from "yup";

export const CreativeSchema = yup.object().shape({
  ID: yup.string().trim().required('Required'),
  adTypes: yup.array().of(yup.string().trim().required('Required')).min(1, "Select one Field"),
  brandId: yup.string().trim().required('Select one Field'),
  brandCollab: yup.array().of(yup.string().trim()),
  categories: yup.array().of(yup.string().trim().required('Required')).min(1, "Select one Field"),
  countries: yup.array().of(yup.string().trim().required('Required')).min(1, "Select one Field"),
  creativeFormats: yup.array().of(yup.string().trim()),
  features: yup.array().of(yup.string().trim()),
  gDriveLink: yup.string().trim(),
  isPublished: yup.boolean(),
  keywords: yup.array().of(yup.string().trim().required('Required')).min(1, "Select one Field"),
  lang: yup.string().trim().required('Select one Field'),
  newTitle: yup.string().trim().required('Required'),
  orientation: yup.string().trim().required('Select one Field'),
  regionId: yup.string().trim().required('Select one Field'),
  subBrands: yup.array().of(yup.string().trim()),
  specialKeywords: yup.array().of(yup.string().trim()),
  stage: yup.string().trim().required('Select one Field'),
  title: yup.string().trim().required('Required'),
  year: yup.string().trim().required('Select one Field'),
  //DT: yup.string().trim(),
  dt: yup.string().trim().required('Select one Field'),
  vimeoLink: yup.string().trim(),
  //fileName: yup.string().trim(),
  fileName: yup.string().trim().required('Required'),
  videoLink: yup.string().trim(),
  thumbImage: yup.string().trim(),
  thumbs: yup.array().of(yup.string().trim()),
  pptDetails: yup.object().shape({
    pptLink: yup.string().trim(),
    pdfLink: yup.string().trim(),
  }),
  imageGallery: yup.array().of(yup.string().trim()),
  mediaType: yup.string().oneOf(['video', 'ppt', 'image']).trim().required('Select one Field'),
}).test('media-type-validation', 'Please fill required fields for selected media type', function(value) {
  const { mediaType } = value;
  
  if (!mediaType) return true; // Let the required validation handle this
  
  switch (mediaType) {
    case 'video':
      if (!value.fileName || !value.videoLink || !value.thumbImage || !value.thumbs || value.thumbs.length === 0) {
        return this.createError({
          message: 'For video media type, file name, video link, thumbnail image, and thumbnails are required'
        });
      }
      break;
      
    case 'ppt':
      if (!value.pptDetails || !value.pptDetails.pptLink || !value.pptDetails.pdfLink) {
        return this.createError({
          message: 'For PPT media type, both PPT link and PPT link are required'
        });
      }
      break;
      
    case 'image':
      if (!value.imageGallery || value.imageGallery.length === 0) {
        return this.createError({
          message: 'For image media type, at least one image in gallery is required'
        });
      }
      break;
  }
  
  return true;
});

